// src/pages/Verify.tsx
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function Verify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string>();

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const token = searchParams.get('token');
        if (!token) {
          setError('Invalid token');
          return;
        }

        const res = await fetch(`/api/auth/verify?token=${token}`);
        if (!res.ok) {
          const text = await res.text();
          setError(text);
          return;
        }

        // Token valid - redirect to chat
        navigate('/chat');
      } catch (e) {
        console.error(e);
        setError('Verification failed');
      }
    };

    verifyToken();
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-zinc-900 via-zinc-900 to-zinc-800">
        <div className="bg-red-50 p-4 rounded">
          <p className="text-red-800">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-zinc-900 via-zinc-900 to-zinc-800">
      <div className="bg-zinc-800/50 border border-white/10 p-4 rounded shadow">
        <p>Verifying...</p>
      </div>
    </div>
  );
}